import { IFormOption } from '@/interfaces';

export const formOptionMapper = (options: IFormOption[]): IFormOption[] => {
    return options.map((option) => ({ id: option.id, name: option.name }));
};
